import { errorMessageOf } from "../errorMessage";

// Submission times are shown in UTC on purpose: the team that designs the survey and the
// client who submitted it are rarely in the same zone, and UTC is the one both can quote.

/** "Oct 24, 2026", in UTC. */
export const formatUtcDate = (iso: string): string =>
  new Date(iso).toLocaleDateString("en-US", {
    timeZone: "UTC",
    month: "short",
    day: "numeric",
    year: "numeric",
  });

/** "10:42 AM UTC". */
export const formatUtcTime = (iso: string): string =>
  `${new Date(iso).toLocaleTimeString("en-US", {
    timeZone: "UTC",
    hour: "numeric",
    minute: "2-digit",
  })} UTC`;

/** Saves a Blob under the given name through a temporary `<a download>`. */
export const saveBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};

const readBlobText = (blob: Blob): Promise<string> =>
  typeof blob.text === "function"
    ? blob.text()
    : new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result ?? ""));
        reader.onerror = () => reject(reader.error);
        reader.readAsText(blob);
      });

/**
 * Message for a failed `responseType: "blob"` call. axios hands the API's JSON error body
 * back as a Blob there, so `errorMessageOf` alone would only show "Request failed with
 * status code 404".
 */
export const blobErrorMessage = async (err: any): Promise<string> => {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await readBlobText(data));
      if (parsed && typeof parsed.message === "string" && parsed.message) {
        return parsed.message;
      }
    } catch {
      // Not JSON (or unreadable): fall through to the generic message.
    }
  }
  return errorMessageOf(err);
};
